/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Updates_Title7Inputs */

const en_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dependency and security updates`)
};

const ar_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديثات الاعتماديات والأمن`)
};

const bn_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপেন্ডেন্সি ও নিরাপত্তা আপডেট`)
};

const de_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abhängigkeits- und Sicherheitsupdates`)
};

const es_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizaciones de dependencias y seguridad`)
};

const fr_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mises à jour de dépendances et de sécurité`)
};

const pt_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizações de dependências e segurança`)
};

const zh_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依赖与安全更新`)
};

const tr_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağımlılık ve güvenlik güncellemeleri`)
};

const ru_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновления зависимостей и безопасности`)
};

const pl_svc_retainer_updates_title7 = /** @type {(inputs: Svc_Retainer_Updates_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizacje zależności i bezpieczeństwa`)
};

/**
* | output |
* | --- |
* | "Dependency and security updates" |
*
* @param {Svc_Retainer_Updates_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_updates_title7 = /** @type {((inputs?: Svc_Retainer_Updates_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Updates_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_updates_title7(inputs)
	if (locale === "bn") return bn_svc_retainer_updates_title7(inputs)
	if (locale === "de") return de_svc_retainer_updates_title7(inputs)
	if (locale === "es") return es_svc_retainer_updates_title7(inputs)
	if (locale === "fr") return fr_svc_retainer_updates_title7(inputs)
	if (locale === "pt") return pt_svc_retainer_updates_title7(inputs)
	if (locale === "zh") return zh_svc_retainer_updates_title7(inputs)
	if (locale === "tr") return tr_svc_retainer_updates_title7(inputs)
	if (locale === "ru") return ru_svc_retainer_updates_title7(inputs)
	if (locale === "pl") return pl_svc_retainer_updates_title7(inputs)
	return en_svc_retainer_updates_title7(inputs)
});
export { svc_retainer_updates_title7 as "svc_retainer_UPDATES_title" }